<template>
  <div class="shadow-blue-sm rounded bg-white px-3 mt-3 pt-3 mb-3">
    <h5 class="d-flex align-items-center mb-5">
      <span class="material-icons mr-2">receipt</span> Detalles del pago
    </h5>
    <div
      class="row mb-2 pr-5 pl-3"
      v-for="product in products"
      :key="product._id._id + 1"
    >
      <div class="col-lg-10">
        <h6 class="mx-sm-auto">{{ product._id.name }}</h6>
      </div>
      <div class="col-lg-2 px-0 text-right">
        <h5 class="text-danger mx-sm-auto">
          SC${{ product.price.toFixed(2) }}
        </h5>
      </div>
    </div>
      <div
      class="row mb-2 pr-5 pl-3"
      v-for="op in otherPayments"
      :key="op._id + 1"
    >
      <div class="col-lg-10">
        <h6 class="mx-sm-auto">{{ op.description }}</h6>
      </div>
      <div class="col-lg-2 px-0 text-right">
        <h5 class="text-danger mx-sm-auto">
          SC${{ (op.sacoin + op.financiamiento).toFixed(2) }}
        </h5>
      </div>
    </div>
    <div class="row mb-2 pr-5 pl-3" v-show="shippingPrice">
      <div class="col-lg-10">
        <h6 class="mx-sm-auto">Envío</h6>
      </div>
      <div class="col-lg-2 px-0 text-right">
        <h5 class="text-danger mx-sm-auto">
          SC${{ shippingPrice.toFixed(2) }}
        </h5>
      </div>
    </div>
    <div class="row bg-blue-light-2 py-2 pr-5 pl-3">
      <div class="col-lg-10">
        <h6 class="mx-sm-auto">Total</h6>
      </div>
      <div class="col-lg-2 px-0 text-right">
        <h5 class="text-danger mx-sm-auto">
          SC${{ total }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentDetail",
  props: {
    products: {
      default: [],
    },
    otherPayments: {
      default: () => [],
    },
    sacoin: {
      type: Number,
      default: 0,
    },
    financiamiento: {
      type: Number,
      default: 0,
    },
    shippingPrice: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    total: function() {
      let total = this.sacoin + this.financiamiento;
      this.otherPayments.forEach(e => {
        total+= e.sacoin + e.financiamiento;
      });
      return total.toFixed(2);
    }
  }
};
</script>